import React, { useState, useEffect } from "react";
// import { Link } from "gatsby";
import { connect } from "react-redux";
import imagesLoaded from "imagesloaded";


import ProductSix from "../product-six";
import Pagination from "../../pagination";

import { showQuickViewModal } from "../../../../actions";

function ProductList(props) {
  let {
    column,
    products,
    filters,
    onSort,
    addToCompare,
    showQuickViewModal,
    searchResults,

    categoryName,
  } = props;

  const [start, setStart] = useState(0);
  const [cols, setCols] = useState(column);

  useEffect(() => {
    document
      .querySelector(".skeleton-body.skel-shop-products")
      .classList.add("loaded");
    document
      .querySelector(".skeleton-body.skel-shop-sidebar")
      .classList.add("loaded");

    setCols(column);
  }, [cols, column]);

  useEffect(() => {
    document
      .querySelector(".skeleton-body.skel-shop-products")
      .classList.add("loaded");
  }, [filters]);
  useEffect(() => {
    document
      .querySelector(".skeleton-body.skel-shop-products")
      .classList.add("loaded");
    setStart(start);
  }, [start]);

  function changePos(pos) {
    setStart(pos);

    document.querySelector(".skeleton-body.skel-shop-products") &&
      document
        .querySelector(".skeleton-body.skel-shop-products")
        .classList.remove("loaded");

    let imgLoad = imagesLoaded(".products", { background: true });

    imgLoad.on("done", function (instance, image) {
      document.querySelector(".skeleton-body.skel-shop-products") &&
        document
          .querySelector(".skeleton-body.skel-shop-products")
          .classList.add("loaded");
    });

    window.scrollTo({
      top: 0,
    });
  }

  function changeFilter(e) {
    onSort(e.target.value);
    setStart(0);
  }

  const grid = {
    "2cols": "col-6",
    "3cols": "col-6 col-md-4 col-lg-4",
    "4cols": "col-6 col-md-4 col-lg-4 col-xl-3",
  };
  const units = { list: 6, "2cols": 6, "3cols": 9, "4cols": 12 };
  const itemsPerPage = units[cols];

  let productslist = products;
  if (searchResults && searchResults.query !== "") {
    const searchedProducts = searchResults.hits.map((hit) => hit._id);

    productslist = products.filter((p) => {
      return searchedProducts.includes(p._id);
    });
  }

  return (
    <>
      {categoryName && (
        <div className="p-1">
          <h1 style={{ fontSize: "2rem" }}>{categoryName}</h1>
        </div>
      )}
      <div className="toolbox">
        <div className="toolbox-left">
          <div className="toolbox-info">
            Showing{" "}
            <span>
              {productslist.length > 0
                ? Math.min(itemsPerPage, productslist.length - start)
                : 0}{" "}
              of {productslist.length}
            </span>{" "}
            Products
          </div>
        </div>

        <div className="toolbox-right">
          <div className="toolbox-sort">
            <label htmlFor="sortby">Sort by:</label>
            <div className="select-custom">
              <select
                name="sortby"
                id="sortby"
                defaultValue={filters?.sortBy ?? ""}
                value={filters?.sortBy ?? ""}
                className="form-control"
                onChange={changeFilter}
              >
                <option value="" style={{color: "#000"}}>Sort items</option>
                <option value="Newest" style={{color: "#000"}}>Newest Items</option>
                <option value="HighToLow" style={{color: "#000"}}>Price: High to Low</option>
                <option value="LowToHigh" style={{color: "#000"}}>Price: Low to High</option>
                <option value="AscOrder" style={{color: "#000"}}>Sort By Name: A To Z</option>
                <option value="DescOrder" style={{color: "#000"}}>Sort By Name: Z To A</option>
                <option value="AscQuantity" style={{color: "#000"}}>Sort By Quantity: Low To High</option>
                <option value="DescQuantity" style={{color: "#000"}}>Sort By Quantity: High To Low</option>
              </select>
            </div>
          </div>

          {/* <div className="toolbox-layout">
            <Link to={process.env.PUBLIC_URL + "/shop/sidebar/list"}>
              <button
                className={`btn-layout ${"list" === cols ? "active" : ""}`}
              >
                <svg width="16" height="10">
                  <rect x="0" y="0" width="4" height="4"></rect>
                  <rect x="6" y="0" width="10" height="4"></rect>
                  <rect x="0" y="6" width="4" height="4"></rect>
                  <rect x="6" y="6" width="10" height="4"></rect>
                </svg>
              </button>
            </Link>

            <Link to={process.env.PUBLIC_URL + "/shop/sidebar/2cols"}>
              <button
                className={`btn-layout ${"2cols" === cols ? "active" : ""}`}
              >
                <svg width="10" height="10">
                  <rect x="0" y="0" width="4" height="4"></rect>
                  <rect x="6" y="0" width="4" height="4"></rect>
                  <rect x="0" y="6" width="4" height="4"></rect>
                  <rect x="6" y="6" width="4" height="4"></rect>
                </svg>
              </button>
            </Link>

            <Link to={process.env.PUBLIC_URL + "/shop/sidebar/3cols"}>
              <button
                className={`btn-layout ${"3cols" === cols ? "active" : ""}`}
              >
                <svg width="16" height="10">
                  <rect x="0" y="0" width="4" height="4"></rect>
                  <rect x="6" y="0" width="4" height="4"></rect>
                  <rect x="12" y="0" width="4" height="4"></rect>
                  <rect x="0" y="6" width="4" height="4"></rect>
                  <rect x="6" y="6" width="4" height="4"></rect>
                  <rect x="12" y="6" width="4" height="4"></rect>
                </svg>
              </button>
            </Link>

            <Link to={process.env.PUBLIC_URL + "/shop/sidebar/4cols"}>
              <button
                className={`btn-layout ${"4cols" === cols ? "active" : ""}`}
              >
                <svg width="22" height="10">
                  <rect x="0" y="0" width="4" height="4"></rect>
                  <rect x="6" y="0" width="4" height="4"></rect>
                  <rect x="12" y="0" width="4" height="4"></rect>
                  <rect x="18" y="0" width="4" height="4"></rect>
                  <rect x="0" y="6" width="4" height="4"></rect>
                  <rect x="6" y="6" width="4" height="4"></rect>
                  <rect x="12" y="6" width="4" height="4"></rect>
                  <rect x="18" y="6" width="4" height="4"></rect>
                </svg>
              </button>
            </Link>
          </div>
      */}
        </div>
      </div>

      <div className="products mb-3">
        <div className="row">
          {productslist
            .slice(start, start + itemsPerPage)
            .map((item, index) => (
              <div className={grid[cols]} key={"product" + index}>
                <div className="skel-pro"></div>

                <ProductSix
                  product={item}
                  type="sidebar"
                  // onAddToCart={ addToCart }
                  onAddToCompare={addToCompare}
                  showQuickView={showQuickViewModal}
                />
              </div>
            ))}
        </div>

        {/* <QuickView /> */}
      </div>

      <Pagination
        aclass={`${"list" === props.cols ? "" : "justify-content-center"}`}
        count={productslist.length}
        unit={itemsPerPage}
        onChange={changePos}
        cols={cols}
        filters={filters}
      />
    </>
  );
}

export default connect(null, { showQuickViewModal })(
  ProductList
);
